<script>

import { Bar } from 'vue-chartjs'
import store from 'vuex-store'
import urlApi from '../../../../router/urlApi'
import Vue from 'vue'

let palette = 'rgba(74,178,227,0.7)'

export default {
  extends: Bar,
  data () {
    return {
      chartData: {
        lable: 'Conteudo',
        labels: ['Primeiros Socorros', 'Legislação', 'Meio Ambiente', 'Direção Defensiva'],
        datasets: [{
          axis: 'y',
          backgroundColor: [palette, palette, palette, palette],
          data: [0, 0, 0, 0]
        }]
      },
      options: {
        legend: {
          display: false,
          position: 'bottom',
          labels: {
            fontColor: palette.fontColor,
            fontFamily: 'sans-serif',
            fontSize: 15,
            usePointStyle: true
          }
        },
        tooltips: {
          bodyFontSize: 15,
          bodyFontFamily: 'sans-serif'
        },
        responsive: true,
        maintainAspectRatio: false,
        fontSize: 25,
      }
    }
  },
  async mounted () {
    await Vue.http.get(urlApi + '/ead/profile').then((response) => {
      this.chartData.datasets[0].data[0] = response.body.materias_teoricas.primeiros_socorros
      this.chartData.datasets[0].data[1] = response.body.materias_teoricas.legislacao_de_transito
      this.chartData.datasets[0].data[2] = response.body.materias_teoricas.protecao_respeito
      this.chartData.datasets[0].data[3] = response.body.materias_teoricas.direcao_defensiva
    })
    this.renderChart(this.chartData, this.options)
  }

}
</script>
